import { defineComponent } from 'vue'
import { DashboardWidgetBase, Stack, ListItem, useWidgetEmits } from '@tenorlab/vue-dashboard'
import { smallCardClasses } from '~/components/shared'
import type { IDashboardWidgetProps } from '@tenorlab/vue-dashboard'
// import { resolveColorFromClass } from '@tenorlab/vue-dashboard/core'
// import { ECharts, EChartsOption } from 'echarts'
// import { useResolvedColors, useEChartDataInterval, WidgetChartBase } from '@/components/shared'
import type { TWidgetEmits } from '@tenorlab/vue-dashboard'

/* small card samples */

const sharedProps = ['widgetKey', 'title', 'parentWidgetKey', 'index', 'maxIndex', 'isEditing'] as string[]

/* small card transparent samples */
export const WidgetSmallCardTransparentSample1 = defineComponent({
  name: 'WidgetSmallCardTransparentSample1',
  // Define runtime props
  props: sharedProps,

  // Use the standard setup function to access Composition API logic
  setup(props: IDashboardWidgetProps, { emit }) {
    const emitHandlers = useWidgetEmits(emit as TWidgetEmits)

    // The setup function must return the render function (TSX)
    return () => (
      <DashboardWidgetBase
        {...props}
        {...emitHandlers}
        hideTitle={true}
        noBorder={true}
        noPadding={true}
        noShadow={true}
        backgroundCssClasses="bg-transparent body-text-color"
      >
        <Stack
          testId="small-card-sample"
          direction="column"
          classNames="flex flex-col h-full overflow-hidden"
        >
          <ListItem classNames="h-full" innerClass="p-0 h-full border border-transparent">
            <div class={smallCardClasses.outerDiv}>
              <span class={smallCardClasses.labelDiv}>No border</span>
              <div class={smallCardClasses.valueDiv}>
                <span class={smallCardClasses.valueLarge}>977,423</span>
                <span class={smallCardClasses.valueSmall}>/year</span>
              </div>
              <div class={smallCardClasses.dateDiv}>
                <div class={smallCardClasses.dateText}>Oct 31, 2025 at 11:41am</div>
              </div>
            </div>
          </ListItem>
        </Stack>
      </DashboardWidgetBase>
    )
  },
})

export const WidgetSmallCardTransparentSample2 = defineComponent({
  name: 'WidgetSmallCardTransparentSample2',
  props: sharedProps,
  setup(props: IDashboardWidgetProps, { emit }) {
    const emitHandlers = useWidgetEmits(emit as TWidgetEmits)
    return () => (
      <DashboardWidgetBase
        {...props}
        {...emitHandlers}
        hideTitle={true}
        noBorder={true}
        noPadding={true}
        noShadow={true}
        backgroundCssClasses="bg-transparent body-text-color"
      >
        <Stack testId="small-card-sample2" direction="column" classNames="overflow-hidden">
          <ListItem innerClass="p-4 border border-card-invert border-opacity-30 ">
            <div class={smallCardClasses.outerDiv}>
              <span class={smallCardClasses.labelDiv}>With border</span>
              <div class={smallCardClasses.valueDiv}>
                <span class={smallCardClasses.valueLarge}>7,569</span>
                <span class={smallCardClasses.valueSmall}>/month</span>
              </div>
              <div class={smallCardClasses.dateDiv}>
                <div class={smallCardClasses.dateText}>Oct 31, 2025 at 11:41am</div>
              </div>
            </div>
          </ListItem>
        </Stack>
      </DashboardWidgetBase>
    )
  },
})

export const WidgetSmallCardTransparentSample3 = defineComponent({
  name: 'WidgetSmallCardTransparentSample3',
  props: sharedProps,
  setup(props: IDashboardWidgetProps, { emit }) {
    const emitHandlers = useWidgetEmits(emit as TWidgetEmits)
    return () => (
      <DashboardWidgetBase
        {...props}
        {...emitHandlers}
        hideTitle={true}
        noBorder={true}
        noPadding={true}
        noShadow={true}
        backgroundCssClasses="bg-transparent body-text-color"
      >
        <Stack testId="small-card-sample3" direction="column" classNames="overflow-hidden">
          <ListItem innerClass="bg-cardchild content-cardchild p-4 border-card-invert border-opacity-30">
            <div class={smallCardClasses.outerDiv}>
              <span class={smallCardClasses.labelDiv}>Cardchild background</span>
              <div class={smallCardClasses.valueDiv}>
                <span class={smallCardClasses.valueLarge}>1410</span>
                <span class={smallCardClasses.valueSmall}>/week</span>
              </div>
              <div class={smallCardClasses.dateDiv}>
                <div class={smallCardClasses.dateText}>Dec 23, 2025 at 11:41am</div>
              </div>
            </div>
          </ListItem>
        </Stack>
      </DashboardWidgetBase>
    )
  },
})

export const WidgetSmallCardTransparentSample4 = defineComponent({
  name: 'WidgetSmallCardTransparentSample4',
  props: sharedProps,
  setup(props: IDashboardWidgetProps, { emit }) {
    const emitHandlers = useWidgetEmits(emit as TWidgetEmits)
    return () => (
      <DashboardWidgetBase
        {...props}
        {...emitHandlers}
        hideTitle={true}
        noBorder={true}
        noPadding={true}
        noShadow={true}
        backgroundCssClasses="bg-transparent body-text-color"
      >
        <Stack testId="small-card-sample4" direction="column" classNames="overflow-hidden">
          <ListItem innerClass="bg-cardchild content-cardchild p-4 border border-opacity-30 border-card-invert">
            <div class={smallCardClasses.outerDiv}>
              <span class={smallCardClasses.labelDiv}>Cardchild background</span>
              <div class={smallCardClasses.valueDiv}>
                <span class={smallCardClasses.valueLarge}>321</span>
                <span class={smallCardClasses.valueSmall}>/day</span>
              </div>
              <div class={smallCardClasses.dateDiv}>
                <div class={smallCardClasses.dateText}>Aug 15, 2025 at 07:49am</div>
              </div>
            </div>
          </ListItem>
        </Stack>
      </DashboardWidgetBase>
    )
  },
})

export const WidgetSmallCardTransparentSample5 = defineComponent({
  name: 'WidgetSmallCardTransparentSample5',
  props: sharedProps,
  setup(props: IDashboardWidgetProps, { emit }) {
    const emitHandlers = useWidgetEmits(emit as TWidgetEmits)
    return () => (
      <DashboardWidgetBase
        {...props}
        {...emitHandlers}
        hideTitle={true}
        noBorder={true}
        noPadding={true}
        noShadow={true}
        backgroundCssClasses="bg-transparent body-text-color"
      >
        <Stack testId="small-card-sample5" direction="column" classNames="overflow-hidden">
          <ListItem innerClass="bg-cardchild content-cardchild p-4 border border-opacity-30 border-card-invert">
            <div class={smallCardClasses.outerDiv}>
              <span class={smallCardClasses.labelDiv}>Cardchild background</span>
              <div class={smallCardClasses.valueDiv}>
                <span class={smallCardClasses.valueLarge}>43</span>
                <span class={smallCardClasses.valueSmall}>/minute</span>
              </div>
              <div class={smallCardClasses.dateDiv}>
                <div class={smallCardClasses.dateText}>Jan 19, 2026 at 09:31am</div>
              </div>
            </div>
          </ListItem>
        </Stack>
      </DashboardWidgetBase>
    )
  },
})
